module.exports = ".content{\r\n    width: 50%;\r\n    height: 100%;\r\n    padding: 40px;\r\n    padding-top: 220px;\r\n    padding-bottom: 150px;\r\n    margin: auto;\r\n    text-align: center;\r\n}\r\n\r\n.check-icon{\r\n    font-size: 5em;\r\n    color: #81C341;\r\n}\r\n\r\n@media (max-width: 820px) {\r\n    .content{\r\n        padding: 20px;\r\n        padding-top: 150px;\r\n        padding-bottom: 150px;\r\n        width: 100%;\r\n    }\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/registration-complete/registration-complete.component.css
// module id = ./src/app/registration-complete/registration-complete.component.css
// module chunks = main